import { useState, useEffect } from 'react';
const cachedScripts = [];

const cleanupLiveAgent = () => {
  if (typeof window.liveagent !== 'undefined') {
    window.liveagent.disconnect();
  }

  if (typeof window._laq !== 'undefined') delete window._laq;
  if (typeof window.liveagent !== 'undefined') delete window.liveagent;
  if (typeof window.liveAgentDeployment !== 'undefined') delete window.liveAgentDeployment;
  const now = new Date();
  now.setMonth(now.getMonth() - 1);
  document.cookie = 'liveagent_sid=';
  document.cookie = 'expires=' + now.toUTCString() + ';';
  document.cookie = 'liveagent_ptid=';
  document.cookie = 'expires=' + now.toUTCString() + ';';
};

export function LoadScript(src) {
  // Keeping track of script loaded and error state
  const [state, setState] = useState({
    loaded: false,
    error: false
  });
  useEffect(() => {
    if (cachedScripts.includes(src)) {
      setState({
        loaded: true,
        error: false
      });
    } else {
      cachedScripts.push(src);
      const script = document.createElement('script');
      script.src = src;
      script.async = true;

      const onScriptLoad = () => {
        setState({
          loaded: true,
          error: false
        });
      };

      const onScriptError = () => {
        // Remove from cachedScripts we can try loading again
        const index = cachedScripts.indexOf(src);
        if (index >= 0) cachedScripts.splice(index, 1);
        script.remove();

        if (typeof cleanup === 'function') {
          cleanup();
        }

        setState({
          loaded: true,
          error: true
        });
      };

      script.addEventListener('load', onScriptLoad);
      script.addEventListener('error', onScriptError);
      document.body.appendChild(script);
      return () => {
        script.removeEventListener('load', onScriptLoad);
        script.removeEventListener('error', onScriptError);
        const index = cachedScripts.indexOf(src);
        if (index >= 0) cachedScripts.splice(index, 1);
        script.remove();

        if (typeof cleanup === 'function') {
          cleanupLiveAgent();
        }
      };
    }
  }, [src]);
  return [state.loaded, state.error];
}